/*
 *   File : privacy.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description : Privacy container
 *  Integrations : 05-10-2022
 *   Version : v1.0
 *   Created : 17-09-2022
 */
/*import packages*/
import { useState, useEffect } from 'react';
import { PrimaryBtn, SecondaryBtn } from '../../components/cta';

/*import components*/
import { Editor } from '../../components/input/index';
import { Loader } from '../../components/loader';
import Nodata from '../../components/note/empty';

/* import services */
import devconfig from '../../config/config';
import APIPost from '../../services/postApi';

const Terms = (props) => {
    const [editorData, setEditorData] = useState("");
    const [current, setCurrent] = useState(false);
    const [loader, setLoader] = useState(false);
    const [success, setSuccess] = useState(null);
    const [error, setError] = useState(null);


    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        getTerms();
    }, []);

    useEffect(() => {
        if (error !== null) {
            setTimeout(() => {
                setError(null);
            }, 3000);
        }
    }, [error])

    useEffect(() => {
        if (success !== null) {
            setTimeout(() => {
                setSuccess(null);
            }, 3000);
        }
    }, [success])

    const getTerms = () => {
        setLoader(true);
        let url = devconfig.admin + "/content/list-content";

        let data = JSON.stringify({
            "type": "TERMS"
        })

        APIPost(url, data).then((response) => {
            if (response.status_code === 200) {
                setLoader(false);
                setEditorData(response.data.text)
            } else {
                setLoader(false)
            }
        })
    }

    const updateTerms = () => {
        let url = devconfig.admin + "/content/update";

        let data = JSON.stringify({
            "type": "TERMS",
            "text": editorData
        })

        APIPost(url, data).then((response) => {
            if (response.status_code === 200) {
                getTerms();
                setSuccess("Privacy updated successfully")
            } else {
                setError(response.message)
            }
        })
    }

    return (
        <>
            <div className="row e-manage-content">
                <div className="col-lg-10 col-8">
                    {
                        !current ?
                            <h6 className="e-card-title">Terms</h6>
                            :
                            <>
                                <span className='e-updated-time'>Updated on: 12 MAR 2020 10:00 AM</span>
                                <h4 className='pt-4 mb-5'>Terms</h4>
                            </>
                    }

                </div>
                <div className="col-lg-2 col-4 text-end">
                    <SecondaryBtn
                        name={!current ? "View" : "Edit"}
                        handleClick={() => setCurrent(!current)} />
                </div>
            </div>
            <div className='row pt-4'>
                {
                    !current ?
                        loader ?
                            <Loader />
                            :
                            <div className='col-lg-12'>
                                <Editor
                                    editorChange={(temp) => {
                                        setEditorData(temp)
                                    }} value={editorData} />
                            </div>
                        :
                        editorData ?
                            <div className='col-lg-12'>
                                <span dangerouslySetInnerHTML={{ __html: editorData }} />
                            </div>
                            :
                            <Nodata />
                }
            </div>
            <div className='row pt-4 mt-3'>
                {
                    !current ?
                        editorData ?
                            <div className='col-lg-1'>
                                <PrimaryBtn
                                    name="Save"
                                    className="e-editor-save"
                                    handleClick={() => {
                                        updateTerms()
                                    }} />
                            </div>
                            :
                            <div className='col-lg-1'>
                                <PrimaryBtn
                                    name="Save"
                                    className="e-editor-save e-disabled" />
                            </div>
                        :
                        null
                }
            </div>

        </>

    )
}

export default Terms;
